import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

//antd
import {
  Input,
  Button,
  Row,
  notification,
  Form,
  Drawer,
  Select,
  InputNumber,
  Col,
  Checkbox,
} from 'antd'

//apis
import { addEmailManager, updateEmailManager } from 'apis/emailManager'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import { getBranches } from 'apis/branch'
import { check } from 'prettier'

export default function EmailManagerForm({ reloadData, children, infoEmail }) {
  const [form] = Form.useForm()
  const dataUser = useSelector((state) => state.navigation)

  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)

  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [branches, setBranches] = useState([])
  const [countriesId, setCountriesId] = useState(null)
  const [regionsId, setRegionsId] = useState(null)
  const [is_carrer, setIsCarrer] = useState(false)
  const [is_booking, setIsBooking] = useState(false)
  const [is_order, setIsOrder] = useState(false)
  const [is_voucher, setIsVoucher] = useState(false)

  const toggle = () => {
    setVisible(!visible)
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) {}
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {}
  }

  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) setBranches(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _addOrupdateEmailManager = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()

      // const dataCountry = countries.find((item) => item.name === formData.country_id)
      // const dataRegion = regions.find((item) => item.name === formData.region_id)
      // const dataBranch = branches.find((item) => item.name === formData.branch_id)
      const body = {
        ...formData,
        is_carrer: is_carrer,
        is_booking: is_booking,
        is_order: is_order,
        is_voucher: is_voucher,
      }
      

      setLoading(true)
      let res
      if (infoEmail) res = await updateEmailManager(infoEmail._id, body)
      else res = await addEmailManager(body)
      setLoading(false)

      if (res.status === 200) {
        if (res.data.success) {
          reloadData()
          notification.success({
            message: `${infoEmail ? 'Cập nhật' : 'Tạo'} email thành công`,
          })
          toggle()
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoEmail ? 'Cập nhật' : 'Tạo'} email thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoEmail ? 'Cập nhật' : 'Tạo'} email thất bại, vui lòng thử lại!`,
        })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getRegions()
    _getCountries()
    _getBranches()
  }, [])

  //reset
  useEffect(() => {
    if (!visible) {
      form.resetFields()
    } else {
      if (infoEmail) {
        form.setFieldsValue({
          ...infoEmail,
          is_carrer: infoEmail.is_carrer || false,
          is_booking: infoEmail.is_booking || false,
          is_order: infoEmail.is_order || false,
          is_voucher: infoEmail.is_voucher || false,
        })
        setIsBooking(infoEmail.is_booking || false)
        setIsCarrer(infoEmail.is_carrer || false)
        setIsOrder(infoEmail.is_order || false)
        setIsVoucher(infoEmail.is_voucher || false)

        // setRegionsId(infoEmail)
        // setCountriesId(infoEmail?.country_info?.name)
      }
    }
  }, [visible, infoEmail])

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Drawer
        title={infoEmail ? 'CẬP NHẬT EMAIL QUẢN LÝ' : 'TẠO EMAIL QUẢN LÝ'}
        centered
        width="60%"
        footer={
          <Row justify="end">
            <Button
              loading={loading}
              size="large"
              type="primary"
              danger
              onClick={_addOrupdateEmailManager}
            >
              {infoEmail ? 'Cập nhật' : 'Tạo'}
            </Button>
          </Row>
        }
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Vui lòng nhập email!' }]}
              >
                <Input size="large" style={{ width: '100%' }} placeholder="Nhập email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
                label="Quốc gia"
                name="country_ids"
              >
                <Select
                  maxTagCount="responsive"
                  size="large"
                  allowClear
                  optionFilterProp="children"
                  showSearch
                  placeholder="Chọn quốc gia"
                  mode={'multiple'}
                  onChange={(e) => setCountriesId(e)}
                >
                  {countries.map((country, index) => (
                    <Select.Option key={index} value={country.country_id}>
                      {country.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
                label="Khu vực"
                name="region_ids"
              >
                <Select
                  maxTagCount="responsive"
                  size="large"
                  allowClear
                  optionFilterProp="children"
                  showSearch
                  placeholder="Chọn khu vực"
                  mode={'multiple'}
                  onChange={(e) => setRegionsId(e)}
                >
                  {regions.map((region, index) =>
                      <Select.Option key={index} value={region.region_id}>
                        {region.name}
                      </Select.Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Chi nhánh" name="branch_ids">
                <Select
                  maxTagCount="responsive"
                  size="large"
                  allowClear
                  optionFilterProp="children"
                  showSearch
                  mode={'multiple'}
                  placeholder="Chọn chi nhánh"
                >
                  {branches.map((branch, index) =>
                      <Select.Option key={index} value={branch.branch_id}>
                        {branch.name}
                      </Select.Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
          <Form.Item  name="is_carrer">
            <Checkbox
              checked={is_carrer}
              value={is_carrer}
              onChange={(check) => {
                setIsCarrer(check.target.checked)
                check.preventDefault();
              }}
            >
              {'Nhận email careers'}
            </Checkbox>
            </Form.Item>
          </Row>
          <Row>
          <Form.Item  name="is_booking">
            <Checkbox
            checked={is_booking}
              value={is_booking}
              onChange={(check) => {
                setIsBooking(check.target.checked)
                check.preventDefault();
              }}
            >
              {'Nhận email booking'}
            </Checkbox>
            </Form.Item>
          </Row>
          <Row>
          <Form.Item  name="is_order">
            <Checkbox
              value={is_order}
              checked={is_order}
              onChange={(check) => {
                setIsOrder(check.target.checked)
                check.preventDefault();
              }}
            >
              {'Nhận email order'}
            </Checkbox>
            </Form.Item>
          </Row>
          <Row>
            <Form.Item name="is_voucher">
              <Checkbox
               value={is_voucher}
               checked={is_voucher}
               onChange={(check) => {
                setIsVoucher(check.target.checked)
                check.preventDefault();
               }}
              >
                {'Nhận email voucher'}
              </Checkbox>
            </Form.Item>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}
